import React from 'react'

export default function AccountingSubProjectPeriodWidget(props) {
  const { subProjectPeriodInfo } = props

  return (
    <>
      {subProjectPeriodInfo && (
        <div style={{ textAlign: 'left' }}>
          <span>{`งวดที่ ${subProjectPeriodInfo?.periodNo}/${subProjectPeriodInfo?.periodOfLength} (${subProjectPeriodInfo?.startAndEndDate})`}</span>
        </div>
      )}
    </>
  )
}
